import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Tooltip from '@mui/material/Tooltip';

// Bandierine SVG (force identical width/height to stretch all flags to same size)
const FLAG_WIDTH = 24;
const FLAG_HEIGHT = 14
const flagStyleBase = { width: FLAG_WIDTH, height: FLAG_HEIGHT, marginRight: 0, verticalAlign: 'middle', display: 'inline-block', overflow: 'hidden' };
// store URLs instead of <img/> elements so we can render them inside a fixed-size container
const flagIcons = {
  ITA: 'https://cdn.jsdelivr.net/gh/hjnilsson/country-flags/svg/it.svg',
  ENG: 'https://cdn.jsdelivr.net/gh/hjnilsson/country-flags/svg/gb.svg',
  FRA: 'https://cdn.jsdelivr.net/gh/hjnilsson/country-flags/svg/fr.svg',
  SPA: 'https://cdn.jsdelivr.net/gh/hjnilsson/country-flags/svg/es.svg',
  GER: 'https://cdn.jsdelivr.net/gh/hjnilsson/country-flags/svg/de.svg',
  POL: 'https://cdn.jsdelivr.net/gh/hjnilsson/country-flags/svg/pl.svg',
};

const LanguageFormatter = ({ row }) => {
  const text = row.language || '';
  // split on any whitespace to support multiple codes separated by spaces
  const codes = text.split(/\s+/).filter(Boolean);

  return (
    <Tooltip title={text} arrow>
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        {codes.length > 0 ? (
          codes.map((code, idx) => {
            const src = flagIcons[code];
            if (src) {
              const containerStyle = Object.assign({}, flagStyleBase, {
                marginRight: idx === codes.length - 1 ? 0 : 6,
                backgroundImage: `url(${src})`,
                backgroundSize: '100% 14px',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
              });
              return (
                <span key={`${code}-${idx}`} style={containerStyle} aria-label={code} />
              );
            }
            return (
              <span key={`${code}-${idx}`} style={{ fontWeight: 700, fontSize: 20, marginRight: idx === codes.length - 1 ? 0 : 6 }}>
                {code}
              </span>
            );
          })
        ) : (
          <span style={{ fontWeight: 700, fontSize: 20 }}>{text}</span>
        )}
      </span>
    </Tooltip>
  );
};

const LanguageTypeProvider = props => <DataTypeProvider formatterComponent={LanguageFormatter} {...props} />;

export default LanguageTypeProvider;
